module.exports = __webpack_public_path__ + "img/429c5506eb1ac4dc83e1bfb872e702be.png";